export function isEmpty(obj) {
  return !obj || (Object.keys(obj).length === 0 && obj.constructor === Object)
}

/**
 * Filters not allowed keys from object.
 *
 * @param {Object} obj - Object to be filtered
 * @param {Array} allowedKeys - Keys that should remain in the obj
 */
export function filter(obj, allowedKeys) {
  return Object.keys(obj)
    .filter(key => allowedKeys.includes(key))
    .reduce((result, key) => {
      result[key] = obj[key]
      return result
    }, {})
}

export function includesValue(obj, value) {
  return Object.values(obj).includes(value)
}

/**
 * Checks if object entities are equal.
 *
 * @param {Object} obj1 - First object to be compared
 * @param {Object} obj2 - Second object to be compared
 * @param {Array} [excludedProperties=[]] - List of properties to exclude (i.e. ['id']) when comparing objects for equality
 */
export function areEntriesEqual(obj1, obj2, excludedProperties = []) {
  if ((!obj1 && obj2) || (obj1 && !obj2)) return false
  if (!obj1 && !obj2) return true

  let [obj1Clone, obj2Clone] = [{ ...obj1 }, { ...obj2 }]
  if (excludedProperties.length) {
    excludedProperties.forEach(prop => {
      delete obj1Clone[prop]
      delete obj2Clone[prop]
    })
  }
  return (
    JSON.stringify(Object.entries(obj1Clone).sort()) ===
    JSON.stringify(Object.entries(obj2Clone).sort())
  )
}

export function hasExactKeys(obj, keysArr) {
  return keysArr.every(key => obj.hasOwnProperty(key)) && Object.keys(obj).length === keysArr.length
}

export function hasEmptyKeys(obj) {
  return Object.values(obj).every(key => key === null || key === '')
}
